import type { OnboardingStep, Placement } from '../types';

// Utility function to determine placement based on target
export const getPlacementForTarget = (target: string | null, isRTL: boolean): Placement => {
  if (!target || target === 'body') {
    return 'center';
  }

  // Map specific targets to their placements
  const targetPlacementMap: Record<string, Placement> = {
    '#language-selector': 'bottom-end',
    '#notification-selector': 'bottom',
    '#new-trip-selector': 'bottom',
    '#customer-selector': isRTL ? 'left' : 'right',
    // Add more mappings as needed
  };

  return targetPlacementMap[target] || 'bottom';
};

// Transform API data to include placement while respecting BE target values
export const transformOnboardingData = (data: OnboardingStep[], isRTL: boolean): OnboardingStep[] => {
  const transformed = data.map((step) => {
    // Only add placement, keep the BE's target value
    return {
      ...step,
      placement: getPlacementForTarget(step.target, isRTL),
    };
  });

  // Sort by nexStepNumber to ensure correct logical order
  const sortedData = transformed.sort((a, b) => {
    // Handle null values by treating them as highest priority (end of sequence)
    if (a.nexStepNumber === null && b.nexStepNumber === null) return 0;
    if (a.nexStepNumber === null) return 1;
    if (b.nexStepNumber === null) return -1;
    return a.nexStepNumber - b.nexStepNumber;
  });

  return sortedData;
};
